import { useMutation, useQueryClient } from "@tanstack/react-query";

import http from "../../../http";
import { GET_PAYMENT_ACCOUNTS, UPDATE_PAYMENT_ACCOUNT } from "../../URL";
import { IAxisErrorResponse } from "../../../interfaces";

interface IEditPaymentAccount {
  accountName: string;
  accountToken: string;
  cardType?: {
    value?: string;
  };
  cardLast4?: string;
  cardMonth?: {
    value?: number;
  };
  cardYear?: {
    value?: number;
  };
  cardHolderName?: {
    value?: string;
  };
  paymentAccountID: string;
  paymentAccountTypeCode: string;
  paymentAccountTypeCodeId?: string;
  active: {
    value: boolean;
  };
}

const updatePaymentAccount = async (fields: IEditPaymentAccount) => {
  await http.post(UPDATE_PAYMENT_ACCOUNT, {
    ...fields,
  });
};

const useUpdatePaymentAccount = () => {
  const queryClient = useQueryClient();  // PR 7831723

  return useMutation<void, IAxisErrorResponse, IEditPaymentAccount>({
    mutationKey: ["update-payment-account"],
    mutationFn: updatePaymentAccount,
    // PR 7831723 Start
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["payment-accounts"] });
      queryClient.invalidateQueries({
        queryKey: ["grid", GET_PAYMENT_ACCOUNTS],
      });
    },
    // PR 7831723 End
  });
};

export default useUpdatePaymentAccount;
